import styled from "styled-components";

export const ScanOrCodeWrapper = styled.span`
    display: flex;
    flex-direction: column;
    width:100%;
    background: red;
`

export const ScanOrCodeHeaderWrapper = styled.span`
    display: flex;
    width: 100%;
    background: yellow;
    flex-direction: row;
    justify-content: space-between;
    align-items:center;
`

export const Wrapper = styled.div`
    padding: 10px;
    height:100vh;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    -ms-flex-align: center;
    -webkit-align-items: center;
    -webkit-box-align: center;

    align-items: center;
    justify-content: flex-start;
    margin-top: 100px;
    flex-direction: column;
`

export const TextStyle = styled.div`
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 18px;
    color: #333333;
    width:100%;
`
